<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> {{ `Skapa ${section}-sida` }} </v-card-title>

      <v-card-text>
        <v-text-field
          label="Sidans namn"
          clearable
          hide-details="true"
          outlined
          v-model="title"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :to="{ name: 'Pages', params: { section } }"> Avbryt </v-btn>

        <v-btn color="primary" :disabled="!title" :loading="loading" @click="save"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
// import { dateTimeToday } from '../../lib/misc'

export default {
  name: 'NewsCreate',
  data() {
    return {
      visible: true,
      title: '',
      loading: false,
    }
  },
  computed: {
    section() {
      return this.$route.params.section
    },
  },
  methods: {
    ...mapActions('pages', { createPage: 'create' }),
    ...mapActions('content', { createContent: 'create' }),

    async save() {
      this.loading = true
      const payload = {
        page_menu_title: this.title,
        page_publish: 'offline',
        page_section: this.section,
        // page_date_created: dateTimeToday,
      }
      const { id } = await this.createPage(payload)
      await this.createContent({ type: 'page', parent_id: id, data: `<p>${this.title}</p>` })

      this.loading = false
      this.$router.replace({ name: 'Page', params: { id } })
    },
  },
}
</script>

<style lang="scss" scoped></style>
